module.exports = __webpack_public_path__ + "static/media/truck-body.f5c769f8.svg";